import { webApiEndpoints } from "../config";
import { mapper } from "../helpers/mapper.helper";
import { AmbientestLogbookRecord, AppCategories, AppRequestType, CodeLogbookRecord, RecordOption, SartokenLogbookRecord, SartokenLogbookRecordDetail } from "../types";

const category: AppCategories = 'logbook'

interface AppLogbookRequest {
    curp?: string,
    idService?: number,
    days: number,
    afore: string
}

export const logbookAdapter = {
    getSartokenServiceList: (): AppRequestType<RecordOption[]>[typeof category]['listaSartokenServicios'] => ({
        endpoint: webApiEndpoints[category].listaSartokenServicios,
        input: null,
        output: (datos) => datos.map(mapper.apiLogbookService)
    }),


    getSartokenServiceLogbook: ({ curp, idService, afore, days }: AppLogbookRequest): AppRequestType<SartokenLogbookRecord[]>[typeof category]['consultaBitacoraApp'] => ({
        endpoint: webApiEndpoints[category].consultaBitacoraApp,
        input: {
            afore,
            curp: curp || '',
            idServicio: idService || 0,
            numeroDias: days
        },
        output: (datos) => datos.map(mapper.apiSartokenServiceLogbook)
    }),

    getSartokenServiceLogbookDetail: (idLogbook: number): AppRequestType<SartokenLogbookRecordDetail>[typeof category]['detalleBitacoraApp'] => ({
        endpoint: webApiEndpoints[category].detalleBitacoraApp,
        input: null,
        parameters: { headers: { idResource: idLogbook.toString() } },
        output: (datos) => mapper.apiSartokenServiceLogbookDetail(datos)
    }),

    getSartokenSmsLogbook: (curp: string, days: number): AppRequestType<CodeLogbookRecord[]>[typeof category]['consultaCodSegApp'] => ({
        endpoint: webApiEndpoints[category].consultaCodSegApp,
        input: { curp, numeroDias: days },
        output: (datos) => datos.map(mapper.apiSartokenSmsLogbook),
        keepCacheBeforeNewRequest: true
    }),

    getAmbientestLogbook: (curp?: string, user?: string): AppRequestType<AmbientestLogbookRecord[]>[typeof category]['consultaBitacoraAmbientacion'] => ({
        endpoint: webApiEndpoints[category].consultaBitacoraAmbientacion,
        input: { curp, usuario: user },
        output: (datos) => datos.map(mapper.apiAmbientestLogbook),
        keepCacheBeforeNewRequest: true
    }),
}